
import { useTranslation } from "react-i18next";

import { CopyOutlined, RedoOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, ConfigProvider, Flex, Modal, Row, Space, Tabs } from "antd";
import ModalMyRequest from "components/elements/Modal/ModalMyRequest";
import { MainLayout } from "components/layouts";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg";
import { MY_REQUEST_TYPE } from "../schemas/myRequestSchema";
import styles from "../styles/MyRequest.module.css";
import MyRequestFilter from "./MyRequestFilter";

function MyRequest({
  selectedMenu = null,
  modalProps = {},
  isModalOpen = false,
  isModalHistoryOpen = false,
  leaveGroupOptions = [],
  modifiedOffSiteOptions = [],
  modifiedEmployeeOptions = [],
  modifiedDocumentTypeOptions = [],
  dropdownWelfareSubTypeByCode = [],
  getPage = () => { },
  onCreate = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
  handleMenuChange = () => { },
  modalRecalOt = () => { },
  handleOpenModal = () => { },
  setOpenRecal = () => { },
  handleOk = () => { },
  handleCancelModal = () => { },
  modalHistory = () => { },
  isEmployee = false,
  useFilter,
  setUseFilter
}) {

  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [useCurrentMenu, setCurrentMenu] = useState("LEAVE");
  // function getItem(rules, label, key, icon) {
  //   let list = [...roles]
  //   if (!list.includes(rules)) {
  //     return {}
  //   }
  //   return {
  //     rules: rules,
  //     label: label,
  //     key: key,
  //     icons: icon,
  //   };
  // }

  function getItem(rules, label, key, icon) {
    let list = [...roles]
    const permissionToCheck = isEmployee
      ? rules.replace("ACCESS_MY_DOCUMENT|MY_REQUEST", "ACCESS_EMPLOYEE|DOCUMENT") //ถ้าเรียก component ที่หน้า พนักงาน ใช้ permission key เป็น ACCESS_EMPLOYEE|DOCUMENT
      : rules;

    if (!list.includes(permissionToCheck)) {
      return {}
    }
    return {
      rules: permissionToCheck,
      label: label,
      key: key,
      icons: icon,
    };
  }

  const MENU = [
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|LEAVE", t('leave.header'), MY_REQUEST_TYPE.LEAVE, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|OFFSITE_WORK", t('offsite_work.header'), MY_REQUEST_TYPE.OFFSITE_WORK, <CopyOutlined style={{ color: "gray" }} />),
    // getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|REDEEM_TIME", t('redeem_time.header'), MY_REQUEST_TYPE.REDEEM_TIME, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|ENDORSE_TIME", t('endorse_time.header'), MY_REQUEST_TYPE.ENDORSE_TIME, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|OVERTIME", t('ot_request'), MY_REQUEST_TYPE.OVERTIME, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|COLLECT_TIME", t('collect_time.header'), MY_REQUEST_TYPE.COLLECT_TIME, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST", t('document_request.header'), MY_REQUEST_TYPE.DOCUMENT_REQUEST, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|CHANGE_SHIFT", t('change_shift.header'), MY_REQUEST_TYPE.CHANGE_SHIFT, <CopyOutlined style={{ color: "gray" }} />),
    getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER", t('warning_letter.header'), MY_REQUEST_TYPE.WARNING_LETTER, <CopyOutlined style={{ color: "gray" }} />),
    ...(isEmployee ? [getItem("ACCESS_MY_DOCUMENT|MY_REQUEST|EXPENSE", t('expense_request.header'), MY_REQUEST_TYPE.EXPENSE, <CopyOutlined style={{ color: "gray" }} />)] : []),
  ];

  const menuBreadcrumbMapping = MENU.reduce((acc, item) => {
    acc[item.key] = item.label;
    return acc;
  }, {});

  const content = ({ isEmployee }) => {
    return (

      <Flex gap={10} vertical={true} >
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "var(--tab-color)",
                itemActiveColor: "var(--tab-color)"
              },
            },
          }}
        >
          <Tabs
            activeKey={selectedMenu}
            items={MENU}
            onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); console.log("Be: ", e) }}
          />
        </ConfigProvider>

        {/* <MyTabsMenu backgroundColor={isEmployee ? 'white' : '#2151b6'} color={isEmployee ? '#2151b6' : 'white'} menuList={MENU} onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); console.log("Be: ", e) }
          } isCard={isEmployee} /> */}
        {/* {MyTabsMenu({ menuList: MENU, onChange: handleMenuChange, isCard: { isEmployee } })} */}

        {<Row justify="end">
          {!isEmployee && selectedMenu !== MY_REQUEST_TYPE.WARNING_LETTER &&
            (<Space direction="horizontal" size={24} style={{ marginRight: '10px' }}>
              <Button style={{ width: "max-content", height: "max-content", borderRadius: "8px", padding: "10px 16px" }}
                onClick={handleOpenModal}
              >
                <Flex align="center" justify="center" gap={8}>
                  <HistoryIcon />
                  <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
                </Flex>
              </Button>
            </Space>)
          }
          {isEmployee && selectedMenu == MY_REQUEST_TYPE.OVERTIME &&
            (<Space direction="horizontal" size={24} style={{ marginRight: '10px' }}>
              <Button style={{ width: "max-content", height: "max-content", borderRadius: "8px", padding: "10px 16px" }}
                onClick={() => { setOpenRecal(true) }}
              >
                <RedoOutlined />
                <span style={{ color: "#344054" }}>{t("becash.label.recalOt")}</span>
              </Button>
              {modalRecalOt?.()}
            </Space>)
          }
          <Space direction="horizontal" size={24}>
            <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "10px 16px", height: "max-content", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>

          </Space>
        </Row>
        }
        {useFilter && (
          <Card width="100%"
            style={{
              borderRadius: "8px",
              backgroundColor: "white",
              border: "1px solid #EAECF0"
            }}
          >
            <MyRequestFilter
              leaveGroupOptions={leaveGroupOptions}
              employeeOptions={modifiedEmployeeOptions}
              documentTypeOptions={modifiedDocumentTypeOptions}
              OffSiteOptions={modifiedOffSiteOptions}
              dropdownWelfareSubTypeByCode={dropdownWelfareSubTypeByCode}
              dataFlag={useCurrentMenu}
              onSubmit={onSubmit}
              onSearch={onSearch}
            />
          </Card>)}
        <ModalMyRequest
          {...modalProps}
          isModalOpen={isModalOpen}
          onCancel={onCancel}
        />
        <Modal title={t("becash.label.history")}
          open={isModalHistoryOpen}
          onOk={handleOk}
          onCancel={handleCancelModal}
          footer={false}
          width="100%"
          maskClosable={false}
          styles={{
            body: {
              maxHeight: "700px",
              overflowY: "auto",
            },
          }}
        >
          {modalHistory()}
        </Modal>
        <Space className={styles.container} size={24} direction="vertical">
          {getPage({ isEmployee })}
        </Space>
      </Flex>
    )
  }

  if (isEmployee) {
    return (<div>
      {content({ isEmployee })}
    </div>)
  }
  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 40 }}>
        <Flex justify="space-between" align="center">
          <Flex vertical>
            <Breadcrumb items={[
              { title: t("home.header"), href: "/" },
              {
                title: t("document_request.header"), href: "",
              },
              {
                title: t("my_request.header"), href: "",
              },
              {
                title: menuBreadcrumbMapping[selectedMenu] || null
              },
            ]} />
            <h2>{menuBreadcrumbMapping[selectedMenu] || t("my_request.header")}</h2>
          </Flex>

          {
            roles.includes(String(MENU.find(o => o.key === selectedMenu)?.rules)?.replace("ACCESS", "CREATE")) && (
              <Button
                onClick={onCreate}
                style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
                type="primary"

              >
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  <span>{t('my_document.create')}</span>
                </Flex>

              </Button>
            )
          }
        </Flex>
        {content({ isEmployee })}
      </Flex>
    </MainLayout>
  );
}

export default MyRequest;
